<mat-card class="overflow-hidden h-100 leaderBoard">
    <mat-card-header [style.background-color]="community?.leaderboard_header_bg_color_hex"
                     class="align-items-center gap-10 noDarkMode">
        <mat-card-title>
            <div class="flex-row gap-10 align-items-center">
                <mat-icon
                        [style.color]="themeService.getReadableColor(community?.leaderboard_header_bg_color_hex)">
                    timeline
                </mat-icon>
                <div [style.color]="themeService.getReadableColor(community?.leaderboard_header_bg_color_hex)">

                    <div [innerHTML]="community?.points_leaderboard_tile_name_rendered || 'Points leaderboard'"
                         class="noMargin"></div>
                </div>
            </div>
        </mat-card-title>
        <mat-card-subtitle>
            @if (community) {
                <div class="d-flex flex-col ml-auto mt-10 mb-10">
                    <app-custom-toggle-group (buttonClick)="listenPointsUpdateEvents($event)" [community]="community"
                                             [compact]="true" [defaultValue]="mode" [options]="modeOptions"
                                             [styledDatePicker]="true"></app-custom-toggle-group>
                </div>
            }
        </mat-card-subtitle>
    </mat-card-header>
    @if (isDialog) {
        <div class="float-end">
            <button class="mat-dialog-close" mat-dialog-close mat-icon-button matTooltip="Close modal"
                    tabindex="-1">
                <mat-icon [style.color]="themeService.getReadableColor(community?.leaderboard_header_bg_color_hex)"
                          class="accent-text">
                    close
                </mat-icon>
            </button>
        </div>
    }
    @if (loading) {
        <div class="flex-row justify-content-center">
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
    }
    @if (!loading && loading != null) {
        @if (users.length) {
            <mat-card-content
                    class="w-100 d-flex flex-col gap-15 pt-10 h-100 scrollControl leaderboardScroll">
                @for (user of users; track userTrack($index, user)) {
                    <div
                            class="flex-row align-items-center gap-10">
                        <div>
                            <div [matMenuTriggerFor]="menu" class="moderator clickable"
                                 (menuOpened)="userInfoMenuOpen = true" (menuClosed)="userInfoMenuOpen = false">
                                <app-online-status-badge [userId]="user.id"></app-online-status-badge>
                            </div>
                            <div [matMenuTriggerFor]="menu" class="miniInitial bg-primary mb-0 clickable"
                                 [class.onlineIndicatorOffset]="!community?.disable_online_icon_next_to_profile_picture"
                                 (menuOpened)="userInfoMenuOpen = true" (menuClosed)="userInfoMenuOpen = false"
                                 mat-card-avatar>
                                <div [appUserAvatar]="user" class="userPicture"></div>
                            </div>
                            <mat-menu #menu="matMenu" class="userDisplayMenu">
                                @if (userInfoMenuOpen) {
                                    <app-user-info [user]="user"></app-user-info>
                                }
                            </mat-menu>
                        </div>
                        <div class="flex-col">
                            <p class="m-0 breakWord">{{ user.username }}</p>
                            <small class="muted"><span [countUp]="user.points" [duration]="500">{{ user.points }}</span>
                                Points</small>
                        </div>
                    </div>
                }
            </mat-card-content>
        } @else {
            <div class="muted p-10">There are no users in this community yet with a large number of points for this
                period
            </div>
        }
    }
</mat-card>

